export { sendEvent } from 'next-flight-server-reference-proxy-loader?id=7f836782606a5075296d034f3ff3d7c3305a71dd51&name=sendEvent!'